var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('staff-edit',_vm._g(_vm._b({attrs:{"removable":"","company-editable":""}},'staff-edit',{ req: _vm.req, companies: _vm.companies, roles: _vm.roles, tasktypes: _vm.tasktypes },false),{ ok: _vm.ok, cancel: _vm.cancel, remove: _vm.remove }))}
var staticRenderFns = []

export { render, staticRenderFns }